import { useEffect } from 'react';

export default function useOnDocumentHidden(onHidden: () => void) {
  useEffect(() => {
    const handle = () => {
      if (document.visibilityState === 'hidden') {
        onHidden();
      }
    };
    document.addEventListener('visibilitychange', handle);
    return () => document.removeEventListener('visibilitychange', handle);
  }, [onHidden]);
}
